export const ROUTES = {
  HOME: "/portfolio",
  PROJECTS: "/projects",
};
